module.exports = __webpack_public_path__ + "img/1440.13d4a4a4.jpg";